import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../app_components/Icon';
import { primitives } from '@lexody/design-tokens';

const ProfileAboutSection = ({ bio }) => {
  if (!bio || bio.length <= 5) {
    return null;
  }

  return (
    <section className="profile-about">
      <header className="profile-about__header">
        <div className="profile-about__titleRow">
          <span className="profile-about__iconCircle" aria-hidden="true">
            <Icon name="user" solid size={20} color={primitives.violet['700']} />
          </span>
          <h2 className="profile-about__title">About me</h2>
        </div>
        <span className="profile-about__quote" aria-hidden="true">&ldquo;</span>
      </header>
      <p className="profile-about__text">{bio}</p>
    </section>
  );
};

ProfileAboutSection.propTypes = {
  bio: PropTypes.string,
};

export default ProfileAboutSection;
